import { JsonConvert } from 'json2typescript';
import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment.prod';
import { Paging } from '../../model/paging/paging';
import { Observable, of } from 'rxjs';
import {
	Session,
	SessionListData,
} from '../../model/troubleshooting/session/session';

@Injectable({
	providedIn: 'root',
})
export class TroubleShootingMockService {
	private _url: string = `${environment.baseAPI}/troubleshooting`;

	constructor() { }

	GETSessions(
		paging: Paging,
		location_id: string,
		since: string,
		until?: string,
		mac_address?: string,
		ip_address?: string,
		username?: string,
	): Observable<Session | any> {
		const mockData = {
			success: true,
			errorCode: 0,
			errorMessage: null,
			data: {
				count: 2,
				data: [
					{
						session_id: 'abc123',
						location_id: 'loc1',
						start_time: '2024-01-01T08:00:00Z',
						end_time: '2024-01-01T14:00:00Z',
						mac_address: '00:11:22:33:44:55',
						ip: '192.168.1. 10',
						username: 'user1',
					},
					{
						session_id: 'def456',
						location_id: 'loc1',
						start_time: '2024-01-01T10:00:00Z',
						end_time: '2024-01-01T21:00:00Z',
						mac_address: '00:11:22:33:44:55',
						ip: '192.168.1. 10',
						username: 'user1',
					},
				],
			},
			elapsed: 1377,
		};

		// const jsonConvert: JsonConvert = new JsonConvert();
		// const response: SessionListData = jsonConvert.deserializeObject(
		// 	mockData,
		// 	SessionListData,
		// );
		return of(mockData);
	}

	GETLogs(
		paging: Paging,
		location_id: string,
		since: string,
		unitl?: string,
		mac_address?: string,
		username?: string
	) {
		const mockData = {
			success: true,
			errorCode: 0,
			errorMessage: null,
			data: {
				count: 2,
				data: [
					{
						"timestamp": "2024-01-01T08:00:00Z",
						"mac_address": "00:11:22:33:44:55",
						"username": "user1",
						"result": "Access-Accept",
						"reason": null,
						"message": "message..."
					},
					{
						"timestamp": "2024-01-01T09:00:00Z",
						"mac_address": "00:11:22:33:44:55",
						"username": "user1",
						"result": "Access-Reject",
						"reason": "No such user",
						"message": "message..."
					}
				],
			},
			elapsed: 1377,
		};
		return of(mockData);
	}
}
